import { GET } from "../../../API/get";

export const fetchExpiredAndExpiring = async ({document_type, filter, page_number}) => {
    const response = await GET(`ftm/expired-and-expiring/${document_type}/${filter}/${page_number}`);
    return response?.status === "Success" ? response : null;
};

export const fetchDocument = async ({document_id, document_type}) => {
    const response = await GET(`ftm/document/files/${document_id}/${document_type}`);
    return response?.status === "Success" ? response : null;
};